/* eslint-disable class-methods-use-this */
import { Component } from 'react';
import {Navigate} from 'react-router-dom';
import TeamLoginForm from '../../common/login/login-form';
import ImpersonationNotice from '../../common/login/impersonation-notice';
import {isAdminLoggedIn} from '../../../utils/sessionAreas';
import {teamLogin} from '../../../actions/login';
import {USER_TYPE_REP} from '../../../data/userTypes';

class TeamLoginPage extends Component {
  render() {
    if (isAdminLoggedIn()) {
      return <Navigate to="/team/my-profile" replace/>;
    }

    return (
      <div className="row">
        <div className="col-md-5 col-md-offset-1">
          <ImpersonationNotice />
          <TeamLoginForm loginAction={teamLogin} type={USER_TYPE_REP}/>
        </div>
      </div>
    );
  }
}

export default TeamLoginPage;
